import { CompanionWeaponBlock, CompanionWeaponBlockBase } from "../model/character"

export const defaultCompanionWeaponBlock: CompanionWeaponBlock = {
    id: "",
    name: "Companion (Weapon)",
    slots: 0,
    acquire: 0,
    critDamage: 0,
    enduranceDamage: 0,
    hitDice: 0,
    hitBonus: 0,
    range: 0,
    resources: 0,
    knowledge: 0,
    influence: 0,
    weaponType: [],
    addFeatures: [],
    removeFeatures: [],
    strongHits: [],
    passives: [],
    reload: 0,
    strongHitRange: 0,
    notes: "",
    armour: 3,
    bodies: 0,
    defence: 12,
    durability: 0,
    mobility: 3,
}

export const defaultCompanionWeaponBase: CompanionWeaponBlockBase = {
    id: "",
    name: "Companion (Weapon)",
    slots: 0,
    acquire: 0,
    critDamage: 0,
    enduranceDamage: 0,
    hitDice: 0,
    hitBonus: 0,
    range: 0,
    resources: 0,
    knowledge: 0,
    influence: 0,
    weaponType: [ 'Companion' ],
    addFeatures: [],
    removeFeatures: [],
    passives: [],
    strongHits: [],
    skillBonusId: "",
    reload: 2,
    strongHitRange: 1,
    notes: "",
    armour: 3,
    bodies: 0,
    defence: 12,
    durability: 0,
    mobility: 3,
}